import React from 'react';

import { ApIcon } from '@alixpartners/ui-components';
import {
  Container,
  Title,
  Helper,
  Section,
  IconWrapper,
} from './LastUpload.styles';
import moment from 'moment';

interface IProps {
  timestamp: string;
}

export const LastUpload: React.FC<IProps> = ({ timestamp }) => {
  const formattedDate = moment
    .utc(timestamp, moment.ISO_8601)
    .local()
    .format('MMMM D, YYYY. H:mm');

  return (
    <Container>
      <Section>
        <Title>Unpublished Data</Title>
        <Helper>Data load: {formattedDate}</Helper>
      </Section>
      <Section>
        <IconWrapper>
          <ApIcon iconName="flash_on" iconSize="19px" iconColor="white" />
        </IconWrapper>
      </Section>
    </Container>
  );
};
